import "../stylesheets/wysiwyg.less"

import "../../../public/assets/javascripts/ckeditor/ckeditor.js"
import "./bootstrap/wysiwyg.js"
